/**
 * Auth object represents authentication-related API endpoints and their methods.
 */
const InstructorAuth = {
  /**
   * Endpoint for Instructor login.
   * @memberof Auth
   * @type {object}
   * @property {string} url - The URL for Instructor login.
   * @property {string} method - The HTTP method for Instructor login (POST).
   */

  instructorLogin: {
    url: "/instructor/auth/login",
    method: "POST",
  },
  instructorSignup: {
    url: "/instructor/auth/signup",
    method: "POST",
  },
  verifyEmail: {
    url: "/instructor/auth/verify-email",
    method: "POST",
  },
  resendVerificationEmail: {
    url: "/instructor/auth/resend-verification-email",
    method: "POST",
  },
  getInstructorDetails: {
    url: "/instructor/auth/me",
    method: "GET",
  },
  changePassword: {
    url: "/instructor/auth/change-password",
    method: "POST",
  },
  instructorForgotPassword: {
    url: "/instructor/forgot-password",
    method: "POST",
  },
  accountLogout: {
    url: "/instructor/auth/logout",
    method: "GET",
  },
};

// Export the Auth object for use in other modules
export default InstructorAuth;
